import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { SuppliersWorkspace } from '@/features/suppliers/pages/suppliers-workspace'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/suppliers/')({
  component: SuppliersRoute,
})

function SuppliersRoute() {
  const { workspaceSlug } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <SuppliersWorkspace
      workspaceSlug={workspaceSlug}
      canWrite={workspace.data?.role !== 'viewer'}
    />
  )
}
